import React from 'react'

const BulkAction = ({ onBulkAction }) => {
  return (
    <select onChange={onBulkAction} value="hint">
      <option value="hint" disabled hidden>
        Choose a Bulk Action
      </option>
      <option value="Delete">Delete</option>
      {/* <option value="Edit">Edit</option> */}
    </select>
  )
}

export default BulkAction



// WEBPACK FOOTER //
// ./src/AssetLibrary/components/BulkAction.js